import {client} from "@/api/client";

export default {
    // 로그인
    async login(email, password) {
        return await client.post("/auth/login", { email, password });
    },
    // 로그아웃
    async logout() {
        return await client.post("/auth/logout");
    },
    // 페이지 권한 조회
    async checkPageAuth(routeName, path) {
        return await client.get(`/auth/routeAuth`, { params: { routeName, path } });
    }
}